<template>
  <v-sheet class="text-center d-flex flex-column align-center bg-background text-on-surface-variant">
    <span class="title font-weight-bold mb-3 mt-2 text-center"
      >{{ $t('component.helpDetails.programDetails', { brand: capitalizedBrand }) }}</span
    >
    <v-sheet
      class="subtitle-2 text-justify mb-4 bg-background footer flex-grow-0 terms"
      style="max-height: 70% !important"
    >
      <ProgramDetailsText />
    </v-sheet>
  </v-sheet>
</template>
<script setup lang="ts">
import ProgramDetailsText from "@/components/ProgramDetailsText/ProgramDetailsText.vue";
import { useAppStore } from "@/stores/app";

const brand = useAppStore().brand;
const capitalizedBrand = brand.charAt(0).toUpperCase() + brand.slice(1);
</script>
<style scoped>
/* span {
  font-weight: 300;
} */
</style>
